import BackendApiClient from './BackendApiClient';

class StatisticsManager {
  get = async (startDate, endDate, metrics) =>
    BackendApiClient.requestAuthorized({
      method: 'GET',
      url: '/staff/statistics',
      params: {
        start_date: startDate,
        end_date: endDate,
        metrics,
      },
    });
}

export default new StatisticsManager();
